export const LARGE_CROWN_RADIUS = Math.sqrt(2) / 4;
export const LAST_ACTION_RADIUS = LARGE_CROWN_RADIUS - 0.02;
export const PIECE_RADIUS = LARGE_CROWN_RADIUS - 0.05;
export const SLOT_RADIUS = 0.075;
export const LINE_MARGIN = 0.2;
